import * as React from 'react';
import {
    ICommand,
    connectToItemCache,
    IItemCache,
    Action,
    IActionProps,
    withSelectedItems,
    withExactlyOneItem,
} from '@ms/items-view';
import { ControlIcons } from 'owa-control-icons';
import { fileKeyFacet } from '../Schema/Facets';
import { getParameterStore } from '../store/ParametersStore';
import { getFilterStore } from '../store/FilterStore';
import { getFilterMenuStore } from '../store/FilterMenuStore';
import { DateRangeOption } from 'owa-files-filter-date-filter';
import { FileExtensionType } from 'owa-files-filter-file-extensions-filter';
import { getFilterContextMenu, FilesFilterContextMenuType } from 'owa-files-filter-contextmenu';
import { AttachmentModel } from 'owa-attachment-model-store';
import getAttachment from 'owa-attachment-model-store/lib/selectors/getAttachment';
import { print, isPrintAllowed, download, isDownloadAllowed } from 'owa-attachment-user-operations';

const DownloadSelectedItemsAction = withSelectedItems()(
    withExactlyOneItem()(
        connectToItemCache(
            (
                itemCache: IItemCache,
                props: { itemKey: string }
            ): Pick<IActionProps, 'isAvailable' | 'onExecute'> => {
                const { itemKey } = props;

                let isAvailable = false;

                let attachmentId;
                let attachment: AttachmentModel;

                const parameterStore = getParameterStore();

                if (itemKey) {
                    attachmentId = {
                        Id: itemCache.demandItemFacet(fileKeyFacet, itemKey).id,
                        mailboxInfo: parameterStore.mailboxInfo,
                    };
                    attachment = getAttachment(attachmentId);
                    isAvailable = isDownloadAllowed(attachment.model);
                }

                return {
                    isAvailable: !!isAvailable,
                    onExecute: isAvailable
                        ? async () => {
                              download(attachmentId, attachment.model);
                          }
                        : undefined,
                };
            }
        )(Action)
    )
);

const PrintSelectedItemsAction = withSelectedItems()(
    withExactlyOneItem()(
        connectToItemCache(
            (
                itemCache: IItemCache,
                props: { itemKey: string }
            ): Pick<IActionProps, 'isAvailable' | 'onExecute'> => {
                const { itemKey } = props;

                let isAvailable = false;

                let attachmentId;
                let attachment: AttachmentModel;

                const parameterStore = getParameterStore();

                if (itemKey) {
                    attachmentId = {
                        Id: itemCache.demandItemFacet(fileKeyFacet, itemKey).id,
                        mailboxInfo: parameterStore.mailboxInfo,
                    };
                    attachment = getAttachment(attachmentId);
                    isAvailable = isPrintAllowed(attachment.model);
                }

                return {
                    isAvailable: !!isAvailable,
                    onExecute: isAvailable
                        ? async () => {
                              print(attachmentId, attachment.model);
                          }
                        : undefined,
                };
            }
        )(Action)
    )
);

const deleteCommand: ICommand = {
    key: 'download',
    name: 'Download', //TODO loacalize
    iconProps: { iconName: ControlIcons.Download },
    action: <DownloadSelectedItemsAction />,
};

const printCommand: ICommand = {
    key: 'print',
    name: 'Print', //TODO loacalize
    iconProps: { iconName: ControlIcons.Print },
    action: <PrintSelectedItemsAction />,
};

function isDateRangeOptionSelectedCheck(value: DateRangeOption): boolean {
    return getFilterStore().dateRangeFilter.selectedValue.option === value;
}

function isExtensionSelected(value: FileExtensionType) {
    return getFilterStore().extensionGroupFilter.selectedValue.has(value.toString());
}

function isExtensionFilterExpanded(): boolean {
    return getFilterMenuStore().isExtensionFilterExpanded;
}

export function getCommandBarActions(hasSelection: boolean) {
    if (hasSelection) {
        return [deleteCommand, printCommand];
    } else {
        return [
            getFilterContextMenu(
                FilesFilterContextMenuType.Files,
                isDateRangeOptionSelectedCheck,
                isExtensionSelected,
                isExtensionFilterExpanded
            ),
        ];
    }
}

export function getContextMenuActions(hasSelection: boolean) {
    return [deleteCommand, printCommand];
}
